import checkout from './checkout/es.js'
import components from './components/es.js'
import menu from './menu/es.js'
import map from './map/es.js'
import merchant from './merchant/es.js'
import merchantAccount from './merchantAccount/es.js'
import system from './system/es.js'
import customerService from './customerService/es.js'
import dashboard from './dashboard/es.js'
import data from './data/es.js'
import payment_links from './payment_links/es.js'
import merchant_auth from './merchant_auth/es.js'
import send_pagements from './send_pagements/es.js'
import developer from './developer/es.js'
import payment_page from './payment_page/es.js'
import createMchCode from './createMchCode/es.js'
import va from './va/es.js'
import tips from './tips/es.js'
import payment_link from './payment_links/es.js'
import kyc from './kyc/es.js'
import serviceProvider from './serviceProvider/es.js'
import acceptPayments from './acceptPayments/es.js'
import no_auth from './no_auth/es.js'
import operation from './operation/es.js'

export default {
  components,
  menu,
  map,
  merchant,
  merchantAccount,
  system,
  customerService,
  dashboard,
  data,
  payment_links,
  merchant_auth,
  send_pagements,
  developer,
  payment_page,
  createMchCode,
  va,
  tips,
  checkout,
  payment_link,
  kyc,
  serviceProvider,
  acceptPayments,
  no_auth,
  operation,
  mfa: {
    timeout_title: 'Verificación de seguridad por tiempo de espera',
    timeout_content: 'Ingrese el código MFA de Google Authenticator',
    title: 'Verificación de seguridad',
    code: 'Código MFA',
    placeholder: 'Por favor ingrese el código MFA',
    required: 'Por favor ingrese el código MFA',
    length: 'Por favor ingrese un código de 6 dígitos',
    invalid: 'El código MFA no es válido',
    enter_code: 'Por favor ingrese el código de verificación MFA de 6 dígitos generado por Google Authenticator'
  }
}
